'use client';

import React from 'react';
import ErrorCommonModule from './index';
import ErrorCode from '@src/v3/assets/svg/errorCode';

interface Error404WithSVGProps {
  /**
   * Button click handler
   */
  onButtonClick?: () => void;
  /**
   * Custom title text
   */
  title?: string;
  /**
   * Custom description text
   */
  description?: string;
  /**
   * Custom button text
   */
  buttonText?: string;
}

export default function Error404WithSVG({
  onButtonClick,
  title = "This page doesn't exist!",
  description,
  buttonText = 'Go Home',
}: Error404WithSVGProps) {
  return (
    <ErrorCommonModule
      icon={
        <div className="sm:w-[235px] sm:h-[235px] w-[158px] h-[158px] rounded-full bg-gradient-to-b from-[#F6CAFF] to-[#BBCCFF] flex items-center justify-center">
          <ErrorCode className="max-sm:w-[100px] max-sm:h-auto" />
        </div>
      }
      title={title}
      description={description}
      buttonText={buttonText}
      onButtonClick={onButtonClick}
      buttonVariant="primary"
    />
  );
}
